module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7bd01b358fbe4512260286183d477685.png";